import { Component, OnInit } from '@angular/core';
import { Bp1configurationRequest, Bp2ConfigurationRequest, IBp1configurationRequest, IBp2ConfigurationRequest, IProductTemplate, ProductTemplate } from '../../../core/models';
import { ProductService } from '../../../core/services/product.service';

@Component({
  selector: 'app-configure-new-product',
  templateUrl: './configure-new-product.component.html',
  styleUrls: ['./configure-new-product.component.scss']
})
export class ConfigureNewProductComponent implements OnInit {

  createConfiguration: IBp1configurationRequest = new Bp1configurationRequest();
  productConfiguration: IBp2ConfigurationRequest = new Bp2ConfigurationRequest();
  previewModel: IProductTemplate = new ProductTemplate();
  configFormIndex: number = 1;  

  constructor(private productService: ProductService) {
    this.previewModel = productService.configureProduct;
    this.productConfiguration = productService.bp2configuration;
    this.createConfiguration = productService.bp1configuration;
  }

  ngOnInit() {
  }

}
